import { useMemo } from "react";
import { useCohortDetails } from "../useCohortDetails";
import { WorkflowPayments } from "../../../../components/Payment/ReportPayments";

export function Payments() {
  const { data } = useCohortDetails();

  const cohort = data?.cohort;
  const activities = useMemo(
    () => cohort?.currentWorkflow?.activities || [],
    [cohort?.currentWorkflow?.activities]
  );

  if (!cohort) {
    return null;
  }

  return (
    <WorkflowPayments
      activities={activities}
      tenantId={cohort.tenantId}
      cohortMode={true}
      showPaper={true}
      title="Payments"
      showActions={false}
      showCreateButton={true}
    />
  );
}
